import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";

// Single Dynamic Card Component with Hover State
const SingleBlogItem = ({ blog, backendBaseUrl }) => {
    const [isHovered, setIsHovered] = useState(false);

    // Card Inline Styles
    const cardStyle = {
        backgroundColor: '#8FC6EA',
        borderRadius: '12px',
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        transform: isHovered ? 'translateY(-8px) scale(1.02)' : 'none',
        boxShadow: isHovered ? '0 12px 24px rgba(0, 0, 0, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.05)',
    };

    // Image Zoom Style
    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.4s ease',
        transform: isHovered ? 'scale(1.08)' : 'scale(1)',
    };

    return (
        <div className="col-md-6 col-lg-3 d-flex align-items-stretch">
            <Link
                className="text-decoration-none w-100"
                to={`/blog/details/${blog?.slug}`}
                style={{ display: 'block', height: '100%' }}
            >
                <article
                    style={cardStyle}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {/* Image Section */}
                    <div style={{ overflow: 'hidden', width: '100%' }}>
                        <img
                            src={`${backendBaseUrl}${blog?.image}`}
                            alt={blog?.title || "blog thumb"}
                            style={imageStyle}
                        />
                    </div>

                    {/* Content Section */}
                    <div className="p-3 d-flex flex-column justify-content-between flex-grow-1">
                        <div className="mb-3">
                            <h5 className="fw-bold text-dark mb-2">
                                {blog?.title}
                            </h5>
                            <p className="text-dark small mb-0 opacity-85">
                                {blog?.short_description?.length > 120
                                    ? `${blog.short_description.slice(0, 120)}...`
                                    : blog?.short_description}
                            </p>
                        </div>

                        {/* Action Link */}
                        <div className="mt-auto pt-2 text-dark fw-bold small d-flex align-items-center gap-2">
                            <span>Read More</span>
                            <i className="fal fa-long-arrow-right"></i>
                        </div>
                    </div>
                </article>
            </Link>
        </div>
    );
};

// Main Blog Component
const BlogCard = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOGS;

        const cachedBlogs = localStorage.getItem("blogs");
        const cacheTimestamp = localStorage.getItem("blogsTimestamp");
        const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

        if (cachedBlogs && cacheTimestamp && (Date.now() - cacheTimestamp < cacheExpiryTime)) {
            // ✅ Use cached data
            setBlogs(JSON.parse(cachedBlogs));
        } else {
            // ❌ Fetch new data from API
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setBlogs(response.data);
                    localStorage.setItem("blogs", JSON.stringify(response.data));
                    localStorage.setItem("blogsTimestamp", Date.now());
                })
                .catch(error => console.error("Error fetching API", error));
        }
    }, []);

    return (
        <div className="blog-area pb-80 pt-60">
            <div className="container">
                <div className="row g-4">
                    {blogs.map((blog, index) => (
                        <SingleBlogItem
                            key={blog?.id || index}
                            blog={blog}
                            backendBaseUrl={backendBaseUrl}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlogCard;